import { AEDFlag, BHDFlag, EGFlag, KWDFlag, OMRFlag, QARFlag, SAFlag } from '@assets/svgs/flags'

export interface CountryOption {
    code: string
    label: string
    domain: string
    qaDomain: string
    Flag?: React.ComponentType<{ width?: number; height?: number; style?: React.CSSProperties }>
}

export type CountryVariant = 'flyin' | 'cleartrip'

export const getFlyinCountryOptions = (t: (key: string) => string): CountryOption[] => [
    { code: 'EG', label: t('countries.egypt'), domain: 'eg.flyin.com', qaDomain: 'meeg.flyin.com', Flag: EGFlag },
    { code: 'UAE', label: t('countries.uae'), domain: 'ae.flyin.com', qaDomain: 'meae.flyin.com', Flag: AEDFlag },
    { code: 'GLOBAL', label: t('countries.global'), domain: 'www.flyin.com', qaDomain: 'me.flyin.com' }
]

export const getCTCountryOptions = (t: (key: string) => string): CountryOption[] => [
    { code: 'AE', label: t('countries.uae'), domain: 'www.cleartrip.ae', qaDomain: 'me.cleartrip.ae', Flag: AEDFlag },
    { code: 'OM', label: t('countries.oman'), domain: 'www.cleartrip.om', qaDomain: 'me.cleartrip.om', Flag: OMRFlag },
    { code: 'QA', label: t('countries.qatar'), domain: 'www.cleartrip.qa', qaDomain: 'me.cleartrip.qa', Flag: QARFlag },
    { code: 'BH', label: t('countries.bahrain'), domain: 'www.cleartrip.bh', qaDomain: 'me.cleartrip.bh', Flag: BHDFlag },
    {
        code: 'KW',
        label: t('countries.kuwait'),
        domain: 'www.cleartrip.com.kw',
        qaDomain: 'me.cleartrip.com.kw',
        Flag: KWDFlag
    },
    { code: 'SA', label: t('countries.saudiArabia'), domain: 'www.cleartrip.sa', qaDomain: 'me.cleartrip.sa', Flag: SAFlag }
]

export const getCountryOptions = (t: (key: string) => string, variant: CountryVariant): CountryOption[] =>
    variant === 'cleartrip' ? getCTCountryOptions(t) : getFlyinCountryOptions(t)

export const detectCurrentCountry = (
    hostname: string,
    countryOptions: CountryOption[],
    isQA: boolean,
    variant: CountryVariant
): CountryOption => {
    const matchedCountry = countryOptions.find(country => {
        const targetDomain = isQA ? country.qaDomain : country.domain
        return hostname.includes(targetDomain)
    })
    return matchedCountry || (variant === 'flyin' ? countryOptions[2] : countryOptions[0])
}
